// Add your custom JS here.

// Navbar Burger Menu Animation
// jQuery(function($) {
//   // Get the 'offcanvas' element
//   var offcanvasElement = document.getElementById('#navbarNavOffcanvas');

//   // Get the 'nav-burger-icon' element
//   var navBurgerIcon = document.querySelector('.nav-burger-icon');

//   // Check if 'offcanvas' element contains 'show' class
//   if (offcanvasElement && offcanvasElement.classList.contains('show')) {
//     // Add 'open' class to 'nav-burger-icon'
//     navBurgerIcon.classList.add('open');
//   } else {
//     // Remove 'open' class from 'nav-burger-icon'
//     navBurgerIcon.classList.remove('open');
//   }
// });

jQuery(function($) {
	$('.nav-burger-icon').click(function() {
		$(this).toggleClass('open');
	});
});